$(document).ready(function (){
    $('body').on('click', '.map_cards_toggle button:not(.active)', function (e) {
        e.preventDefault();
        const href = '#' + $(this).attr('aria-controls');

        $('.map_cards_toggle button.active').removeClass('active').attr('aria-selected', 'false');
        $(this).addClass('active').attr('aria-selected', 'true');

        toggleMapCards(href === '#map' ? 'map' : 'cards');
        history.replaceState(null, null, href);
    });

    if (window.location.hash === '#map') {
        const mapTab = $('.map_cards_toggle [aria-controls="map"]');
        if (mapTab.length) {
            mapTab.trigger('click');
        }
    }
    $(document).on('keydown', '.map_cards_toggle [role="tab"]', function (e) {

        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;

        e.preventDefault();

        const $visibleTabs = $('.map_cards_toggle [role="tab"]:visible');

        const $currentTab = $(this);
        const currentIndex = $visibleTabs.index($currentTab);

        if (currentIndex === -1) return;

        let newIndex = currentIndex;

        if (e.key === 'ArrowRight') {
            newIndex = (currentIndex + 1) % $visibleTabs.length;
        } else if (e.key === 'ArrowLeft') {
            newIndex = (currentIndex - 1 + $visibleTabs.length) % $visibleTabs.length;
        }

        $visibleTabs.eq(newIndex).focus();
    });


    $('body').on('click', '.filter_toggle, .filter_close', function (e){
        e.preventDefault();
        $('html, body').scrollTop(0).toggleClass('no-scroll');
        $('.filter_list').slideToggle(0);
        $(this).parent().toggleClass('open');
        $('.filter_list').toggleClass('open');
    });
    $('body').on('click', '.float_filtered_cards__heading', function (e){
        $(this).toggleClass('open');
        $('.float_filtered_cards__list').slideToggle(150);
    });


    $('#filters').on('submit', function (e) {
        e.preventDefault();

        const form = $(this);

        const minPriceInput = form.find('input[name="price_min"]');
        const maxPriceInput = form.find('input[name="price_max"]');

        const currentMin = parseFloat(minPriceInput.val());
        const currentMax = parseFloat(maxPriceInput.val());

        const defaultMin = parseFloat(minPriceInput.attr('min'));
        const defaultMax = parseFloat(maxPriceInput.attr('max'));

        const formData = form.serializeArray();

        const cleanedFormData = formData.filter((field) => {
            if (field.name === 'price_min') {
                return currentMin !== defaultMin;
            }
            if (field.name === 'price_max') {
                return currentMax !== defaultMax;
            }
            return true;
        });

        const grouped = {};
        $.each(cleanedFormData, function (i, field) {
            if (!grouped[field.name]) {
                grouped[field.name] = [];
            }
            grouped[field.name].push(field.value);
        });

        const query = [];
        $.each(grouped, function (key, values) {
            const encodedKey = encodeURIComponent(key);
            const encodedValues = encodeURIComponent(values.join(',')).replace(/%2C/g, ',');
            query.push(encodedKey + '=' + encodedValues);
        });

        const newUrl = window.location.pathname + '?' + query.join('&');

        window.history.pushState({}, '', newUrl);

        const ajaxData = {
            action: 'filter_apartments',
            filters: grouped
        };

        $.ajax({
            url: "/wp-admin/admin-ajax.php",
            type: 'POST',
            data: ajaxData,
            dataType: 'json',
            beforeSend: function () {
                $('.mobile_filter_toggles.open .filter_toggle').trigger('click');
                $('.apartment_result_cards').addClass('loading');
                $('.apartment_result_map').addClass('loading');
            },
            success: function (response) {
                if (response.success) {
                    buildingsData = response.data.buildings_data;
                    currentPage = 1;
                    renderCards(currentPage, true);
                    updateMarkers(buildingsData);

                    $('.float_filtered_cards__heading').html(
                        `${buildingsData.length} ${buildingsData.length === 1 ? 'property' : 'properties'}
                        <i class="icon icon-arrow-bottom"></i>`
                    );
                    $('.apartment_result_cards__sort-count').text(
                        `Showing ${buildingsData.length} ${buildingsData.length === 1 ? 'property' : 'properties'}`
                    );

                    if (typeof initPropertyCardSliders === 'function') {
                        initPropertyCardSliders();
                    }

                    document.getElementById('show-more-btn').style.display = buildingsData.length > buildingsPerPage ? 'flex' : 'none';

                    if(buildingsData.length === 0){
                        $('.apartment_result_map:not(.no_results)').addClass('no_results');
                        $('.apartment_result_cards:not(.no_results)').addClass('no_results');
                        $('.apartment_no_result').css('display', 'flex');
                    } else {
                        $('.apartment_result_map.no_results').removeClass('no_results');
                        $('.apartment_result_cards.no_results').removeClass('no_results');
                        $('.apartment_no_result').css('display', 'none');
                    }

                    $('.apartment_result_cards').removeClass('loading');
                    $('.apartment_result_map').removeClass('loading');
                } else {
                    $('.apartment_result_cards').removeClass('loading');
                    $('.apartment_result_map').removeClass('loading');
                    console.warn(response.data.message);
                }
            },
            complete: function (){
            }
        });
    });

    $('body').on('click', '#filters button[type="reset"], #clear_filters', function (e){
        e.preventDefault();
        const newUrl = window.location.pathname + window.location.hash;
        window.history.pushState({}, '', newUrl);
        window.location.reload();
        /*$('#filters input').each(function () {
            const type = $(this).attr('type');
            if (type === 'checkbox' || type === 'radio') {
                $(this).prop('checked', false);
            } else if (type === 'text' || type === 'number') {
                $(this).val('');
            }
        });
        $('#filters').trigger('submit');
        const ajaxData = {
            action: 'filter_apartments',
        };
        $.ajax({
            url: "/wp-admin/admin-ajax.php",
            type: 'POST',
            data: ajaxData,
            dataType: 'json',
            beforeSend: function () {
                $('.mobile_filter_toggles.open .filter_toggle').trigger('click');
                $('.apartment_result_cards').addClass('loading');
                $('.apartment_result_map').addClass('loading');
            },
            success: function (response) {
                if (response.success) {
                    buildingsData = response.data.buildings_data;
                    currentPage = 1;
                    renderCards(currentPage);
                    updateMarkers(buildingsData);

                    $('.apartment_result_cards__sort-count').text(
                        `Showing ${buildingsData.length} ${buildingsData.length === 1 ? 'property' : 'properties'}`
                    );

                    if (typeof initPropertyCardSliders === 'function') {
                        initPropertyCardSliders();
                    }

                    if(window.innerWidth < 1024){
                        document.getElementById('show-more-btn').style.display = buildingsData.length > buildingsPerPage ? 'flex' : 'none';
                    }

                    if(buildingsData.length === 0){
                        $('.apartment_result_map:not(.no_results)').addClass('no_results');
                        $('.apartment_result_cards:not(.no_results)').addClass('no_results');
                        $('.apartment_no_result').css('display', 'flex');
                    } else {
                        $('.apartment_result_map.no_results').removeClass('no_results');
                        $('.apartment_result_cards.no_results').removeClass('no_results');
                        $('.apartment_no_result').css('display', 'none');
                    }

                    $('.apartment_result_cards').removeClass('loading');
                    $('.apartment_result_map').removeClass('loading');
                } else {
                    $('.apartment_result_cards').removeClass('loading');
                    $('.apartment_result_map').removeClass('loading');
                    console.warn(response.data.message);
                }
            }
        });*/
    });


    const minPrice = parseInt($("#min_price").attr('min'));
    const maxPrice = parseInt($("#max_price").attr('max'));

    const $slider = $("#price_range");
    const $minInput = $("#min_price");
    const $maxInput = $("#max_price");


    $slider.slider({
        range: true,
        min: minPrice,
        max: maxPrice,
        values: [parseInt($minInput.val()), parseInt($maxInput.val())],
        create: function(event, ui) {
            const handles = $slider.find(".ui-slider-handle");
            handles.eq(0).parent().append('<span class="slider-label">$' + formatPrice($minInput.val()) + '</span><span class="slider-label">$' + formatPrice($maxInput.val()) + '</span>');
            updateAmountDisplay($slider.slider("values"));

            $(this).find(".ui-slider-handle").attr({
                "role": "slider",
                "aria-valuemin": minPrice,
                "aria-valuemax": maxPrice,
                "tabindex": 0
            });

            updateSliderLabels($slider.slider("values"));
        },
        slide: function(event, ui) {
            updateAmountDisplay(ui.values);
            $minInput.val(ui.values[0]);
            $maxInput.val(ui.values[1]);
            updateSliderLabels(ui.values);
        }
    });

    function updateAmountDisplay(values) {
        $("#amount").val("$" + values[0] + " - $" + values[1]);
    }

    function updateSliderLabels(values) {
        const handles = $slider.find(".ui-slider-handle");
        handles.siblings(".slider-label").eq(0).text("$" + formatPrice(values[0]));
        handles.siblings(".slider-label").eq(1).text("$" + formatPrice(values[1]));
        $(".ui-slider-handle").eq(0).attr("aria-label", "Minimum price: " + "$" + formatPrice(values[0]));
        $(".ui-slider-handle").eq(1).attr("aria-label", "Maximum price: " + "$" + formatPrice(values[1]));
    }

    $minInput.on("change", function() {
        let minVal = parseInt($minInput.val());
        let maxVal = parseInt($maxInput.val());

        if (minVal < minPrice) minVal = minPrice;
        if (minVal > maxVal) minVal = maxVal;

        $slider.slider("values", 0, minVal);
        updateAmountDisplay($slider.slider("values"));
        updateSliderLabels($slider.slider("values"));
    });

    $maxInput.on("change", function() {
        let minVal = parseInt($minInput.val());
        let maxVal = parseInt($maxInput.val());

        if (maxVal > maxPrice) maxVal = maxPrice;
        if (maxVal < minVal) maxVal = minVal;

        $slider.slider("values", 1, maxVal);
        updateAmountDisplay($slider.slider("values"));
        updateSliderLabels($slider.slider("values"));
    });

    initPropertyCardSliders();
});

function formatPrice(value) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function toggleMapCards(view) {
    if (view === 'cards') {
        $('.apartment_result_map').hide();
        $('.apartment_result_cards').show();
        $('.apartment_result_sort').show();
    } else if (view === 'map') {
        $('.apartment_result_map').show();
        $('.apartment_result_cards').hide();
        $('.apartment_result_sort').hide();
        $('.map_cards_toggle a[href="#map"]').addClass('active');

        if (window.map && window.lastBounds) {
            setTimeout(() => {
                google.maps.event.trigger(map, 'resize');
                map.fitBounds(lastBounds);
            }, 0);
        }
    }
}

function initPropertyCardSliders() {
    const sliders = document.querySelectorAll('.property_card_slider.swiper');

    sliders.forEach((sliderEl) => {
        new Swiper(sliderEl, {
            spaceBetween: 0,
            rewind: true,
            watchOverflow: true,
            slidesPerView: 1,
            nested: true,
            simulateTouch: true,
            grabCursor: true,

            navigation: {
                nextEl: sliderEl.querySelector('.slide_next'),
                prevEl: sliderEl.querySelector('.slide_prev'),
            },
            pagination: {
                el: sliderEl.querySelector('.property_card_pagination'),
                clickable: false,
                dynamicBullets: true,
            },
            on: {
                touchStart(swiper, event) {
                    event.stopPropagation();
                },
                touchMove(swiper, event) {
                    event.stopPropagation();
                },
                init(swiper) {
                    updateAriaHidden(swiper);
                },
                slideChange(swiper) {
                    updateAriaHidden(swiper);
                },
            }
        });
    });
}
window.initPropertyCardSliders = initPropertyCardSliders;

const buildingsPerPage = 6;
let currentPage = 1;

function renderCards(page, isFiltering = false) {
    currentPage = page;
    const container = document.getElementById('cards-container');
    const cards_on_map_container = document.getElementById('float-cards-container');
    if (!container && !cards_on_map_container) {
        return;
    }
    if(window.innerWidth >= 1024 && isFiltering){
        document.getElementById('float-cards').style.display = 'block';
        cards_on_map_container.innerHTML = '';
        cards_on_map_container.innerHTML = buildingsData.map(b => b.info).join('');
    }

    container.innerHTML = '';

    const start = (page - 1) * buildingsPerPage;
    const end = start + buildingsPerPage;
    const currentItems = buildingsData.slice(start, end);

    container.innerHTML = currentItems.map(b => b.card_html).join('');
    initPropertyCardSliders();

    if(window.innerWidth >= 1024){
        renderPagination();
    }

    window.scrollBy({ top: -10000, behavior: 'smooth' });
}

function renderPagination() {
    const totalPages = Math.ceil(buildingsData.length / buildingsPerPage);
    const pagination = document.getElementById('pagination-container');
    const showMoreBtn = document.getElementById('show-more-btn');

    // если всего 1 страница — скрыть пагинацию
    if (totalPages <= 1) {
        pagination.style.display = 'none';
        showMoreBtn.style.display = 'none';
    } else {
        if(window.innerWidth >= 1024) {
            // pagination.style.display = 'flex';
        }
        if(window.innerWidth < 1024){
            // showMoreBtn.style.display = 'flex';
        }
    }

    pagination.innerHTML = '';

    for (let i = 1; i <= totalPages; i++) {
        const pageBtn = document.createElement('button');
        pageBtn.textContent = i;
        pageBtn.classList.add('pagination-button');
        if (i === currentPage) pageBtn.classList.add('active');
        pageBtn.addEventListener('click', () => renderCards(i));
        pagination.appendChild(pageBtn);
    }
}

document.addEventListener('DOMContentLoaded', () => {
    renderCards(1);

    const showMoreBtn = document.getElementById('show-more-btn');
    if (showMoreBtn) {
        showMoreBtn.addEventListener('click', function (e) {
            e.preventDefault();
            renderNextPage();
        });
    }
});
function renderNextPage() {
    const start = currentPage * buildingsPerPage;
    const end = start + buildingsPerPage;
    const nextItems = buildingsData.slice(start, end);

    const container = document.getElementById('cards-container');
    let firstNewCard = null;

    nextItems.forEach((b, index) => {
        const wrapper = document.createElement('div');
        wrapper.innerHTML = b.card_html;
        const card = wrapper.firstElementChild;

        container.appendChild(card);

        if (index === 0) {
            firstNewCard = card;
        }
    });

    initPropertyCardSliders();

    currentPage++;

    if ((currentPage) * buildingsPerPage >= buildingsData.length) {
        document.getElementById('show-more-btn').style.display = 'none';
    }

    if (firstNewCard) {
        if($(firstNewCard).find('button').length){
            $(firstNewCard).find('button').first().focus();
        } else{
            $(firstNewCard).find('a').focus();
        }
    }
}
